import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classes from './PostForm.module.css';
import PostFormDrawers from './PostFormDrawers/PostFormDrawers';
import SelectCategory from 'assets/images/categoryIconEmpty.png';
import { ClosePostDialogue, DeletePostDialogue, TitleNeededDialogue } from 'components/Dialogues';
import Button from 'components/UI/Button/Button';
import DisplayTextArea from 'components/UI/DisplayTextArea/DisplayTextArea';
import FormDialogue from 'components/UI/FormDialogue/FormDialogue';
import GiftPostIntro from 'components/UI/GiftPostIntro/GiftPostIntro';
import ImagesDisplayInputField from 'components/UI/ImagesInput/ImagesDisplayInputField/ImagesDisplayInputField';
import PostItMessage from 'components/UI/PostItMessage/PostItMessage';
import Spinner from 'components/UI/Spinner/Spinner';
import TagInput from 'containers/UI/Tags/TagInput/TagInput';
import {
  capitalize,
  categoryImages,
  checkValidity,
  combineAndDedupArrays,
  extractTimeFromDateTime,
  formatDateRangeForPostFormDisplay,
  formatTimeRangeForPostFormDisplay,
  getAuthorName,
  isFormValid,
  preparePostDateForSubmission,
  sortLogNamesForDisplay,
  timeStringToDateTime,
  updateObject,
} from 'shared/utility';
import * as actions from 'store/actions';

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controls: {
        images: {
          value: this.props.postImages.map((image) => image.Id),
          validation: {
            required: false,
            validationError: 'Please add a photo',
          },
          valid: true,
          touched: false,
        },
        contentCategory: {
          value: '',
          contentCategoryImage: null,
          validation: {
            required: false,
            validationError: 'Please choose a category',
          },
          valid: true,
          touched: false,
        },
        title: {
          elementType: 'textarea',
          elementConfig: {
            type: 'textarea',
            placeholder: 'Title',
            readOnly: true,
            maxRows: 2,
          },
          value: '',
          validation: {
            required: true,
            validationError: 'Please enter a post title',
          },
          valid: false,
          touched: false,
        },
        desc: {
          elementType: 'textarea',
          elementConfig: {
            type: 'textarea',
            placeholder: 'About',
            readOnly: true,
          },
          value: '',
          validation: {
            required: false,
            validationError: 'Please tell us about your post',
          },
          valid: true,
          touched: false,
        },
        dateStart: {
          elementType: 'textarea',
          elementConfig: {
            type: 'textarea',
            readOnly: true,
            placeholder: 'Date',
            maxRows: 2,
          },
          value: new Date(),
          granularity: 'date',
          validation: {
            required: true,
            validationError: 'Please enter a valid date',
          },
          readOnly: true,
          valid: true,
          touched: false,
        },
        dateEnd: {
          elementType: 'datePicker',
          elementConfig: {
            type: 'controlled',
            readOnly: true,
            placeholder: 'End Date (Optional)',
          },
          value: '',
          granularity: 'date',
          ongoing: false,
          validation: {
            required: false,
            validationError: 'Please enter a valid date',
          },
          valid: true,
          touched: true,
        },
        timeStart: {
          value: null,
          validation: {
            required: false,
          },
          valid: true,
          touched: false,
        },
        timeEnd: {
          value: null,
          validation: {
            required: false,
          },
          valid: true,
          touched: false,
        },
        whatTags: {
          elementType: 'tagInput',
          elementConfig: {
            type: 'tagInput',
            placeholder: 'General Tags',
          },
          value: [],
          tagClassName: 'WhatTags',
          validation: {
            required: false,
            validationError: 'Please enter a location for post',
          },
          valid: true,
          touched: false,
        },
        locationTags: {
          elementType: 'tagInput',
          elementConfig: {
            type: 'tagInput',
            placeholder: 'Locations',
          },
          value: [],
          tagClassName: 'LocationTags',
          validation: {
            required: false,
            validationError: 'Please enter a location for post',
          },
          valid: true,
          touched: false,
        },
        whoTags: {
          elementType: 'tagInput',
          elementConfig: {
            type: 'tagInput',
            placeholder: 'People',
          },
          value: [],
          tagClassName: 'WhoTags',
          validation: {
            required: false,
            validationError: 'Please enter a tag for post',
          },
          valid: true,
          touched: false,
        },
        location: {
          elementType: 'controlled',
          elementConfig: {
            type: 'controlled',
            readOnly: true,
            placeholder: 'Location',
          },
          location: '',
          location2: '',
          locationIcon: null,
          locationFav: false,
          locationFavId: null,
          geoLocation: {
            lat: null,
            lng: null,
          },
          center: {
            lat: null,
            lng: null,
          },
          zoom: null,
          mapTypeId: null,
          pitch: null,
          heading: null,
          validation: {
            required: false,
            validationError: 'Please enter a valid location or address',
          },
          valid: true,
          touched: false,
        },
        logs: {
          value: [],
          logNames: [],
          tagClassName: 'Logs',
          validation: {
            required: true,
            validationError: 'Please select a log for post',
          },
          valid: false,
          touched: false,
        },
        gifteeMembers: {
          ids: [],
          names: [],
          valid: true,
          touched: false,
        },
        gifteeLogs: {
          ids: [],
          valid: true,
          touched: false,
        },
      },
      // datePickerConfig: {
      //   range: true,
      //   isDateRange: true,
      // },
      // locationTags: this.props.locationTags,
      // whoTags: this.props.whoTags,
      // whatTags: this.props.whatTags,
      defaultMapSettings: {
        geoLocation: {
          lat: 39.5,
          lng: -98.35,
        },
        center: {
          lat: 39.5,
          lng: -98.35,
        },
        zoom: 3,
        mapTypeId: 'roadmap',
      },
      renderStatus: {
        showModalDrawer: false,
        drawerContents: null,
        dialogueContents: null,
        showGiftIntro: false,
        showGiftMessage: true,
      },
      isDraft: false,
      isNewlyCreatedDraft: false,
      isGift: this.props.isGift === true,
      formIsValid: false,
      formTouched: false,
      uppyUploading: false,
    };
    this.selectedLogsAndGiftees = React.createRef();
  }

  componentDidMount() {
    if (this.props.postingAs.UserId !== null) {
      this.props.onFetchTags();
      this.props.onFetchLogsDetails(this.props.postingAs.UserId, this.props.isManagedUser);
    }

    if (this.props.post) {
      this.initializePostData();
      if (this.props.isDraft) this.setState({ isDraft: true });
    }

    if (this.props.isGift === true) {
      this.toggleGiftIntro();
    }

    // Previously, if a user created a post or draft, we'd automatically select their private log.
    // We've decided not to do this for now. I've kept the code for this commented out below in case we decide to revert.
    // if(this.props.logs && this.props.logs.length > 0 && this.props.newPost === true && !this.props.isGift){
    // 	let privateLog = this.props.logs.length > 0 && this.props.logs.filter(log => log.Log.Visibility ===
    // 	'Private').length > 0 ? this.props.logs.filter(log => log.Log.Visibility === 'Private')[0] : null;
    // 	if(privateLog !== null ) {
    // 		this.handleUpdateLogControls(privateLog.Log.Id, privateLog.Log.Name, false, true)
    // 	}
    // }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.post !== this.props.post && this.props.post) {
      if (this.props.isDraft) this.setState({ isDraft: true });
      this.initializePostData();
    }

    // Previously, if a user created a post or draft, we'd automatically select their private log.
    // We've decided not to do this for now. I've kept the code for this commented out below in case we decide to revert.
    // if((prevProps.logs.length === 0 && this.props.logs.length > 0 || this.props.logs
    // !== prevProps.logs) && this.props.newPost === true && !this.props.isGift){
    // 	let privateLog = this.props.logs.filter(log => log.Log.Visibility === 'Private').length > 0 ?
    // 	this.props.logs.filter(log => log.Log.Visibility === 'Private')[0] : null;
    // 	if(privateLog !== null && !this.state.controls.logs.value.includes(privateLog.Log.Id))
    // 	this.handleUpdateLogControls(privateLog.Log.Id, privateLog.Log.Name, false, true)
    // }

    if (this.props.submitted === true && prevProps.submitted === false) {
      if (!this.state.isDraft) {
        // const logId = this.state.controls.logs.value[0];
        this.handleClose();
      }
    }

    if (prevProps.postingAs.UserId === null && this.props.postingAs.UserId !== null) {
      this.props.onFetchTags();
    }

    if (this.props.postImages !== prevProps.postImages && this.props.imagesUpdated === true) {
      const updatedControls = updateObject(this.state.controls, {
        images: updateObject(this.state.controls.images, {
          value: this.props.postImages.length > 0 ? this.props.postImages.map((image) => image.Id) : [],
          valid: true,
          touched: true,
        }),
      });
      this.setState({ controls: updatedControls });
    }
  }

  /* Post image methods */

  handleImageDeletion = (index, imageId) => {
    this.props.onPostImageRemoval(index, imageId, 'post');
    this.setState({ formTouched: true });
  };

  /* Title selector methods */

  handleCategoryPromptSelection = (categoryName, tags) => {
    const ammendedTagList = combineAndDedupArrays(this.state.controls.whatTags.value, tags);

    const updatedControls = updateObject(this.state.controls, {
      whatTags: updateObject(this.state.controls.whatTags, {
        value: ammendedTagList,
        valid: true,
        touched: true,
      }),
      contentCategory: updateObject(this.state.controls.contentCategory, {
        value: categoryName,
        valid: true,
        touched: true,
      }),
    });
    const formIsValid = isFormValid(updatedControls);
    this.setState({ formTouched: true, controls: updatedControls, formIsValid });
  };

  /* Content type selector methods */
  setContentCategory = (categoryName) => {
    const updatedControls = updateObject(this.state.controls, {
      contentCategory: updateObject(this.state.controls.contentCategory, {
        value: categoryName,
        valid: true,
        touched: true,
      }),
    });
    const formIsValid = isFormValid(updatedControls);
    this.setState({ formTouched: true, controls: updatedControls, formIsValid });
  };

  /* Date selection methods */

  handleDateSelect = (date, dateType) => {
    const newDate = date ? (date.ts !== undefined ? new Date(date.ts) : date) : null;
    const updatedControls = updateObject(this.state.controls, {
      [dateType]: updateObject(this.state.controls[dateType], {
        value: newDate,
        valid: newDate ? true : dateType === 'dateEnd',
        touched: true,
        ongoing: dateType === 'dateEnd' ? false : this.state.controls.dateEnd.ongoing,
      }),
    });
    const formIsValid = isFormValid(updatedControls);
    this.setState({ formTouched: true, controls: updatedControls, formIsValid });
  };

  /* Iniitalizing Fetched Post - on post edit */

  initializePostData = () => {
    const privateLog =
      // eslint-disable-next-line no-nested-ternary
      this.props.logs && this.props.logs.length > 0
        ? this.props.logs.filter((log) => log.Visibility === 'Private').length > 0
          ? this.props.logs.filter((log) => log.Visibility === 'Private')[0]
          : null
        : null;
    let logIds = [];

    // if(!this.props.isEditingPreview){

    // if(this.state.isDraft || this.props.isDraft && this.props.post.Logs.length === 0){

    // 	//Previously, if a user created a post or draft, we'd automatically select their private log.
    // 	//We've decided not to do this for now. I've kept the code for this commented out below in case we decide to revert.
    // 	// logIds = this.props.post.Post.LogsForDraft !== undefined ?
    // 	this.props.post.Post.LogsForDraft.split(',').map(log => log) : (privateLog ? [privateLog.Id] : []);
    // 	logIds = this.props.post.Post.LogsForDraft !== undefined ? this.props.post.Post.LogsForDraft.split(',').map(log => log) :  [];
    // } else if(this.props.formAction === 'create' && this.props.newPost === true ){
    // 	logIds = [];

    // 	// logIds = privateLog ? [privateLog.Id] : [];
    // } else
    if (this.props.post.Logs.length > 0) {
      // console.log('(this.props.post.Logs.length > 0)');
      logIds = this.props.post.Logs.map((log) => log.Id);
    }
    // }

    const logNames = logIds.length > 0 ? this.props.postingAs.Logs.filter((log) => logIds.includes(log.Id)).map((log) => log.Name) : [];

    const gifteeMemberIds = this.props.isEditingPreview ? this.props.post.Post.SendToUserId : [];
    const gifteeMemberNames = [];
    if (gifteeMemberIds.length > 0 && this.props.postingAs.KnownUsers)
      this.props.postingAs.KnownUsers.filter((member) => gifteeMemberIds.includes(member.User.UserId)).forEach((member) => {
        const memberdisplayName = getAuthorName(member.User.NickName, member.User.FirstName);
        gifteeMemberNames.push(memberdisplayName);
      });
    // eslint-disable-next-line no-nested-ternary
    const images = this.props.isEditingPreview
      ? this.props.postImages
      : this.props.post.Files && this.props.post.Files.Files.length
      ? this.props.post.Files.Files
      : [];
    const updatedControls = updateObject(this.state.controls, {
      images: {
        ...this.state.controls.images,
        value: images.map((file) => file.Id),
        valid: this.state.controls.images.validation.required === true ? images.length > 0 : true,
      },
      contentCategory: {
        ...this.state.controls.contentCategory,
        value: this.props.post.Post.Type,
        valid:
          this.state.controls.contentCategory.validation.required === true
            ? checkValidity(this.props.post.Post.Type, this.state.controls.contentCategory.validation)
            : true,
      },
      title: {
        ...this.state.controls.title,
        value: this.props.post.Post.Name,
        valid:
          this.state.controls.title.validation.required === true
            ? checkValidity(this.props.post.Post.Name, this.state.controls.title.validation)
            : true,
      },
      dateStart: {
        ...this.state.controls.dateStart,
        value:
          this.props.isGift || !this.props.post.Post.DateStartCalc
            ? ''
            : this.props.post.Post.PostStartDateIsNullDay
            ? this.props.post.Post.PostStartDateIsNullMonth
              ? `00/00/${this.props.post.Post.DateStartCalc.split('/')[2]}`
              : `${this.props.post.Post.DateStartCalc.split('/')[0]}/00/${this.props.post.Post.DateStartCalc.split('/')[2]}`
            : this.props.post.Post.DateStartCalc,
        granularity: this.props.post.Post.PostStartDateIsNullDay ? (this.props.post.Post.PostStartDateIsNullMonth ? 'year' : 'month-year') : 'date',
        valid: this.props.post.Post.DateStartCalc
          ? this.state.controls.dateStart.validation.required === true && !this.props.isGift
            ? checkValidity(this.props.post.Post.DateStartCalc, this.state.controls.dateStart.validation)
            : true
          : false,
      },
      dateEnd: {
        ...this.state.controls.dateEnd,
        value: this.props.isGift
          ? ''
          : !this.props.post.Post.DateEndCalc || this.props.post.Post.DateEndCalc === 'Ongoing'
          ? null
          : this.props.post.Post.PostEndDateIsNullDay
          ? this.props.post.Post.PostEndDateIsNullMonth
            ? `00/00/${this.props.post.Post.DateEndCalc.split('/')[2]}`
            : `${this.props.post.Post.DateEnd.split('/')[0]}/00/${this.props.post.Post.DateEndCalc.split('/')[2]}`
          : this.props.post.Post.DateEndCalc,
        granularity: this.props.post.Post.PostEndDateIsNullDay ? (this.props.post.Post.PostEndDateIsNullMonth ? 'year' : 'month-year') : 'date',
        valid:
          this.state.controls.dateEnd.validation.required === true && !this.props.isGift
            ? checkValidity(this.props.post.Post.DateEndCalc, this.state.controls.dateEnd.validation)
            : true,
        ongoing: this.props.post.Post.DateEndCalc && !this.props.isGift && this.props.post.Post.DateEndCalc === 'Ongoing',
      },
      timeStart: {
        ...this.state.controls.timeStart,
        value: !this.props.isGift && this.props.post.Post.TimeStartCalc ? timeStringToDateTime(this.props.post.Post.TimeStartCalc) : null,
      },
      timeEnd: {
        ...this.state.controls.timeEnd,
        value: !this.props.isGift && this.props.post.Post.TimeEndCalc ? timeStringToDateTime(this.props.post.Post.TimeEndCalc) : null,
      },
      locationTags: {
        ...this.state.controls.locations,
        value: this.props.post.Tags.LocationTags && this.props.post.Tags.LocationTags.length > 0 ? this.props.post.Tags.LocationTags : [],
        valid:
          this.state.controls.locationTags.required === true
            ? this.props.post.Tags.LocationTags
              ? checkValidity(this.props.post.Tags.LocationTags, this.state.controls.locationTags.validation)
              : false
            : true,
      },
      whatTags: {
        ...this.state.controls.whatTags,
        value: this.props.post.Tags.WhatTags && this.props.post.Tags.WhatTags.length > 0 ? this.props.post.Tags.WhatTags : [],
        valid:
          this.state.controls.whatTags.required === true
            ? this.props.post.Tags.WhatTags
              ? checkValidity(this.props.post.Tags.WhatTags, this.state.controls.whatTags.validation)
              : false
            : true,
      },
      whoTags: {
        ...this.state.controls.people,
        value: this.props.post.Tags.WhoTags && this.props.post.Tags.WhoTags.length > 0 ? this.props.post.Tags.WhoTags : [],
        valid:
          this.state.controls.whoTags.required === true
            ? this.props.post.Tags.WhoTags
              ? checkValidity(this.props.post.Tags.WhoTags, this.state.controls.whoTags.validation)
              : false
            : true,
      },
      desc: {
        ...this.state.controls.desc,
        value: this.props.post.Post.Desc,
        valid:
          this.state.controls.desc.validation.required === true
            ? checkValidity(this.props.post.Post.Desc, this.state.controls.desc.validation)
            : true,
      },
      location: {
        ...this.state.controls.location,
        location: this.props.post.Post.Location ? this.props.post.Post.Location : '',
        location2: this.props.post.Post.Location2 ? this.props.post.Post.Location2 : '',
        locationIcon: this.props.post.Post.LocIcon ? this.props.post.Post.LocIcon : null,
        locationFav: this.props.post.Post.LocFav ? this.props.post.Post.LocFav : false,
        locationFavId: this.props.post.Post.FavId ? this.props.post.Post.FavId : null,
        geoLocation:
          this.props.post.Post.Location || this.props.post.Post.Location2
            ? this.props.post.Post.Lat
              ? { lat: parseFloat(this.props.post.Post.Lat), lng: parseFloat(this.props.post.Post.Lng) }
              : { lat: parseFloat(this.props.post.Post.MapLat), lng: parseFloat(this.props.post.Post.MapLng) }
            : this.state.defaultMapSettings.geoLocation,
        center:
          this.props.post.Post.Location || this.props.post.Post.Location2
            ? { lat: parseFloat(this.props.post.Post.MapLat), lng: parseFloat(this.props.post.Post.MapLng) }
            : this.state.defaultMapSettings.center,
        zoom: this.props.post.Post.Zoom ? parseFloat(this.props.post.Post.Zoom) : this.state.controls.location.zoom,
        mapTypeId: this.props.post.Post.MapType ? this.props.post.Post.MapType : this.state.controls.location.mapTypeId,
        pitch: this.props.post.Post.Pitch ? parseFloat(this.props.post.Post.Pitch) : this.state.controls.location.pitch,
        heading: this.props.post.Post.Heading ? parseInt(this.props.post.Post.Heading, 10) : this.state.controls.location.heading,
        valid:
          this.state.controls.location.validation.required === true
            ? checkValidity(this.props.post.Post.Location, this.state.controls.location.validation)
            : true,
      },
      logs: {
        ...this.state.controls.logs,
        value: logIds,
        logNames,
        valid: this.state.controls.logs.validation.required === true ? (this.props.formAction === 'create' ? !!privateLog : logIds.length > 0) : true,
      },
      gifteeMembers: {
        ...this.state.controls.gifteeMembers,
        ids: gifteeMemberIds,
        names: gifteeMemberNames,
      },
    });
    let formIsValid = true;
    for (const inputIdentifier in this.state.controls) {
      formIsValid = (updatedControls[inputIdentifier].valid || this.state.controls[inputIdentifier].validation.required === false) && formIsValid;
    }
    // const logSelectorIsValid = logIds.length > 0;
    this.setState({ controls: updatedControls, formIsValid, formTouched: false });
  };

  /* Shared Methods */

  inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(this.state.controls, {
      [controlName]: updateObject(this.state.controls[controlName], {
        value: event.target.value,
        valid: checkValidity(event.target.value, this.state.controls[controlName].validation),
        touched: true,
      }),
    });
    const formIsValid = isFormValid(updatedControls);
    this.setState({ formTouched: true, controls: updatedControls, formIsValid });
  };

  handleTimeSelect = (dateTime, timeType) => {
    const updatedControls = updateObject(this.state.controls, {
      [timeType]: updateObject(this.state.controls[timeType], {
        ...this.state.controls[timeType],
        value: dateTime ? new Date(dateTime) : null,
      }),
    });
    this.setState({ formTouched: true, controls: updatedControls });
  };

  handleTimeClear = (timeType) => {
    const updatedControls = updateObject(this.state.controls, {
      [timeType]: updateObject(this.state.controls[timeType], {
        ...this.state.controls[timeType],
        value: null,
      }),
    });
    this.setState({ formTouched: true, controls: updatedControls });
  };

  handleDateClear = (dateType) => {
    const updatedControls = updateObject(this.state.controls, {
      [dateType]: updateObject(this.state.controls[dateType], {
        ...this.state.controls[dateType],
        value: '',
        ongoing: false,
      }),
    });
    this.setState({ formTouched: true, controls: updatedControls });
  };

  handleOngoingSelection = () => {
    const updatedControls = updateObject(this.state.controls, {
      dateEnd: updateObject(this.state.controls.dateEnd, {
        ...this.state.controls.dateEnd,
        value: null,
        touched: true,
        valid: true,
        ongoing: true,
      }),
    });
    this.setState({ formTouched: true, controls: updatedControls });
  };

  /* Tag selector methods */

  updateTags = (tagsToBeAdded, tagsToBeRemoved, tagCategory) => {
    let ammendedTagList = combineAndDedupArrays(this.state.controls[tagCategory].value, tagsToBeAdded);
    ammendedTagList = ammendedTagList.filter((tag) => tagsToBeRemoved.includes(tag) === false);
    const updatedControls = updateObject(this.state.controls, {
      [tagCategory]: updateObject(this.state.controls[tagCategory], {
        value: ammendedTagList,
        valid: true,
        touched: true,
      }),
    });
    this.setState({ formTouched: true, controls: updatedControls });
  };

  /* LogSelector related methods */

  handleUpdateLogControls = (logId, logName, formIsTouched, newPost) => {
    let updatedIdsArray = [];
    let updatedNamesArray = [];
    if (this.state.controls.logs.value.includes(logId) === true) {
      updatedIdsArray = [...this.state.controls.logs.value.filter((item) => item !== logId)];
      updatedNamesArray = [...this.state.controls.logs.logNames.filter((item) => item !== logName)];
    } else {
      updatedIdsArray = newPost ? [logId] : [...this.state.controls.logs.value, logId];
      updatedNamesArray = newPost ? [logName] : [...this.state.controls.logs.logNames, logName];
    }
    const formTouched = formIsTouched !== false;
    const updatedControls = updateObject(this.state.controls, {
      logs: updateObject(this.state.controls.logs, {
        value: updatedIdsArray,
        logNames: updatedNamesArray,
        valid: updatedIdsArray.length > 0,
        touched: formTouched,
      }),
    });
    const formIsValid = isFormValid(updatedControls);

    this.setState({ formTouched, controls: updatedControls, formIsValid });
  };

  handleGifteesUpdate = (ids, names, isAdding, logIds) => {
    let updatedIdsArray = [];
    let updatedNamesArray = [];
    let updatedLogIdsArray = [...this.state.controls.gifteeLogs.ids];
    if (isAdding === true) {
      updatedIdsArray = combineAndDedupArrays(this.state.controls.gifteeMembers.ids, ids);
      updatedNamesArray = combineAndDedupArrays(this.state.controls.gifteeMembers.names, names);
      if (logIds !== undefined) updatedLogIdsArray = combineAndDedupArrays(updatedLogIdsArray, logIds);
    } else {
      updatedIdsArray = [...this.state.controls.gifteeMembers.ids].filter((id) => ids.includes(id) === false);
      updatedNamesArray = [...this.state.controls.gifteeMembers.names].filter((name) => names.includes(name) === false);
      if (logIds !== undefined) updatedLogIdsArray = updatedLogIdsArray.filter((id) => logIds.includes(id) === false);
    }

    const updatedControls = updateObject(this.state.controls, {
      gifteeMembers: updateObject(this.state.controls.gifteeMembers, {
        ids: updatedIdsArray,
        names: updatedNamesArray,
        touched: true,
      }),
      gifteeLogs: updateObject(this.state.controls.gifteeLogs, {
        ids: updatedLogIdsArray,
        touched: true,
      }),
    });

    this.setState({ formTouched: true, controls: updatedControls });
  };

  handleGifteesClear = () => {
    const updatedControls = updateObject(this.state.controls, {
      gifteeMembers: updateObject(this.state.controls.gifteeMembers, {
        ids: [],
        names: [],
      }),
      gifteeLogs: updateObject(this.state.controls.gifteeLogs, {
        ids: [],
      }),
    });
    this.setState({ controls: updatedControls });
  };

  /* Location Selection Methods */

  handleLocationUpdate = (locationLine1, locationLine2, geoLocation, center, zoom, mapTypeId, pitch, heading, locIcon, locFav, favId) => {
    const location1 = locationLine1 || locationLine2 ? locationLine1 : this.state.controls.location.location;
    const location2 = locationLine1 || locationLine2 ? locationLine2 : this.state.controls.location.location2;
    const locationIcon = locFav === false ? null : locIcon || this.state.controls.location.locationIcon;
    const locationFavId = locFav === false ? null : favId || this.state.controls.location.locationFavId;
    const locationFav = locFav !== undefined ? locFav : this.state.controls.location.locationFav;
    const updatedGeoLocation = geoLocation || this.state.controls.location.geoLocation;
    const updatedCenter = center || this.state.controls.location.center;
    const updatedZoom =
      zoom ||
      (!locationFav && (locationLine1 || locationLine2 || locationIcon || !this.state.controls.location.zoom)
        ? 15
        : this.state.controls.location.zoom);
    const updatedMapTypeId =
      mapTypeId || (this.state.controls.location.mapTypeId ? this.state.controls.location.mapTypeId : this.state.defaultMapSettings.mapTypeId);
    const updatedPitch = pitch || this.state.controls.location.pitch;
    const updatedHeading = heading || this.state.controls.location.heading;
    const updatedControls = updateObject(this.state.controls, {
      location: updateObject(this.state.controls.location, {
        location: location1,
        location2,
        locationIcon,
        locationFav,
        locationFavId,
        geoLocation: updatedGeoLocation,
        center: updatedCenter,
        zoom: updatedZoom,
        mapTypeId: updatedMapTypeId,
        pitch: updatedPitch,
        heading: updatedHeading,
      }),
    });
    this.setState({ formTouched: true, controls: updatedControls });
  };

  handleLocationDeletion = () => {
    const updatedControls = updateObject(this.state.controls, {
      location: updateObject(this.state.controls.location, {
        location: '',
        location2: '',
        geoLocation: this.state.defaultMapSettings.geoLocation,
        zoom: this.state.defaultMapSettings.zoom,
        mapTypeId: this.state.defaultMapSettings.mapTypeId,
        pitch: null,
        heading: null,
      }),
    });
    this.setState({ formTouched: true, controls: updatedControls });
  };

  /* Post saving / gifting / submission */

  handlePostSubmit = (isDraft, createDraftCopy) => {
    const dateStart = preparePostDateForSubmission(this.state.controls.dateStart.value, false);
    const dateEnd = preparePostDateForSubmission(this.state.controls.dateEnd.value, this.state.controls.dateEnd.ongoing);

    const timeStart = extractTimeFromDateTime(this.state.controls.timeStart.value);
    const timeEnd = extractTimeFromDateTime(this.state.controls.timeEnd.value);

    if ((this.props.newPost === true && !this.state.isDraft) || createDraftCopy) {
      this.props.onAddPost(
        this.props.postingAs.UserId,
        this.props.isManagedUser,
        this.state.controls.logs.value,
        this.state.controls.title.value,
        this.state.controls.contentCategory.value,
        dateStart,
        dateEnd,
        timeStart,
        timeEnd,
        this.state.controls.desc.value,
        this.state.controls.images.value,
        [],
        this.state.controls.whatTags.value,
        this.state.controls.whoTags.value,
        this.state.controls.locationTags.value,
        this.state.controls.dateEnd.ongoing,
        this.state.controls.location.location,
        this.state.controls.location.location2,
        this.state.controls.location.locationIcon,
        this.state.controls.location.locationFav,
        this.state.controls.location.locationFavId,
        this.state.controls.location.mapTypeId,
        this.state.controls.location.geoLocation,
        this.state.controls.location.center,
        this.state.controls.location.pitch,
        this.state.controls.location.heading,
        this.state.controls.location.zoom,
        isDraft,
      );
    } else if (this.props.post) {
      this.props.onUpdatePost(
        this.props.post.Post.PostId,
        this.state.controls.logs.value,
        this.state.controls.title.value,
        this.state.controls.contentCategory.value,
        dateStart,
        dateEnd,
        timeStart,
        timeEnd,
        this.state.controls.desc.value,
        this.state.controls.images.value,
        [],
        this.state.controls.whatTags.value,
        this.state.controls.whoTags.value,
        this.state.controls.locationTags.value,
        this.props.removedImageIds,
        this.state.controls.dateEnd.ongoing,
        this.state.controls.location.location,
        this.state.controls.location.location2,
        this.state.controls.location.locationIcon,
        this.state.controls.location.locationFav,
        this.state.controls.location.locationFavId,
        this.state.controls.location.mapTypeId,
        this.state.controls.location.geoLocation,
        this.state.controls.location.center,
        this.state.controls.location.pitch,
        this.state.controls.location.heading,
        this.state.controls.location.zoom,
        isDraft,
        null,
        this.props.isManagedUser,
        this.props.postingAs.UserId,
      );
    }

    if (isDraft === true) {
      this.toggleDialogue('Draft Saved Dialogue');
      this.setState({ isDraft: true });
    } else {
      this.setState({ isDraft: false });
    }
  };

  handlePreviewLaunch = (isGift) => {
    const dateStart = preparePostDateForSubmission(this.state.controls.dateStart.value, false);
    const dateEnd = preparePostDateForSubmission(this.state.controls.dateEnd.value, this.state.controls.dateEnd.ongoing);

    const timeStart = extractTimeFromDateTime(this.state.controls.timeStart.value);
    const timeEnd = extractTimeFromDateTime(this.state.controls.timeEnd.value);
    let logs = [];
    const post = {
      Name: this.state.controls.title.value,
      Type: this.state.controls.contentCategory.value,
      DateStart: dateStart,
      DateStartCalc: dateStart,
      Desc: this.state.controls.desc.value,
      LogIds: [],
      DateEnd: dateEnd,
      DateEndCalc: dateEnd,
      TimeStart: timeStart,
      TimeStartCalc: timeStart,
      TimeEnd: timeEnd,
      TimeEndCalc: timeEnd,
    };
    if (this.props.post && this.props.post.Post.PostId) post.PostId = this.props.post.Post.PostId;
    post.isGift = !!isGift;
    post.UserId = this.props.postingAs.UserId;
    post.isManagedUser = this.props.isManagedUser;
    post.isDraft = this.state.isDraft ? this.state.isDraft : false;
    if (this.state.controls.images.value) post.ImageIds = this.state.controls.images.value;
    if (this.props.removedImageIds) post.RemovedImageIds = this.props.removedImageIds;
    if (this.state.controls.logs.value && this.state.controls.logs.value.length > 0) {
      post.LogIds = this.state.controls.logs.value;
      logs = this.state.controls.logs.value.map((logId, i) => ({
        Id: this.state.controls.logs.value[i],
        Name: this.state.controls.logs.logNames[i],
      }));
    }
    if (this.state.controls.dateEnd.ongoing) {
      post.Ongoing = true;
    }
    post.Location = this.state.controls.location.location;
    post.Location2 = this.state.controls.location.location2;
    if (this.state.controls.location.locationIcon !== null) {
      post.LocIcon = this.state.controls.location.locationIcon;
    }
    if (this.state.controls.location.locationFav !== null) {
      post.LocFav = this.state.controls.location.locationFav;
    }
    if (this.state.controls.location.locationFavId !== null) {
      post.FavId = this.state.controls.location.locationFavId;
    }
    if (this.state.controls.location.mapTypeId !== null) {
      post.MapType = this.state.controls.location.mapTypeId;
    }
    if (this.state.controls.location.pitch !== null) {
      post.Pitch = this.state.controls.location.pitch;
    }
    if (this.state.controls.location.heading !== null) {
      post.Heading = this.state.controls.location.heading;
    }
    if (this.state.controls.location.geoLocation.lat !== null) {
      post.MapLat = this.state.controls.location.geoLocation.lat;
    }
    if (this.state.controls.location.geoLocation.lng !== null) {
      post.MapLng = this.state.controls.location.geoLocation.lng;
    }
    if (this.state.controls.location.center.lat !== null) {
      post.Lat = this.state.controls.location.center.lat;
    }
    if (this.state.controls.location.center.lng !== null) {
      post.Lng = this.state.controls.location.center.lng;
    }
    if (this.state.controls.location.zoom !== null) {
      post.Zoom = this.state.controls.location.zoom;
    }
    if (this.state.controls.gifteeMembers.ids !== null) {
      post.SendToUserId = this.state.controls.gifteeMembers.ids;
    }
    const tags = {
      WhatTags: this.state.controls.whatTags.value,
      WhoTags: this.state.controls.whoTags.value,
      LocationTags: this.state.controls.locationTags.value,
    };

    const postObject = {
      Post: post,
      Tags: tags,
      Logs: logs,
    };
    this.props.onSetPreviewPost(postObject);
    this.props.history.push('/life-shared/posts/preview');
  };

  handleDraftSaving = () => {
    if (this.state.controls.title.value.length > 0) {
      const createDraftCopy = !this.state.isDraft;
      if (!this.state.isDraft && !this.state.isNewlyCreatedDraft) {
        this.setState({ isNewlyCreatedDraft: true });
      } else if (this.state.isDraft && this.state.isNewlyCreatedDraft) {
        this.setState({ isNewlyCreatedDraft: false });
      }
      this.handlePostSubmit(true, createDraftCopy);
    } else {
      this.toggleDialogue('Title Needed Dialogue');
    }
  };

  handleDraftsRedirect = () => {
    this.props.close();
    this.props.onToggleGiftsDraftsModal();
  };

  /* Delete post related methods */

  handlePostDelete = () => {
    this.props.onHandlePostDelete(this.props.post.Post.PostId, this.props.isManagedUser, this.props.postingAs.UserId);
    if (this.state.isDraft) {
      this.handleDraftsRedirect();
    } else {
      this.props.close('delete');
    }
  };

  toggleRenderStatus = (drawerType) => {
    let drawerContents = drawerType;
    let showModalDrawer = true;
    if (drawerType === null || drawerType === this.state.renderStatus.drawerContents) {
      showModalDrawer = false;
      drawerContents = null;
    }
    const updatedRenderStatus = updateObject(this.state.renderStatus, {
      drawerContents,
      showModalDrawer,
    });
    this.setState({ renderStatus: updatedRenderStatus });
  };

  toggleGiftIntro = () => {
    let showModalDrawer = false;
    let drawerContents = null;
    let showGiftIntro = true;
    if (this.state.renderStatus.showGiftIntro || this.hasDismissedGiftIntro) {
      showGiftIntro = false;
      showModalDrawer = true;
      drawerContents = 'Gift To';
    }
    // const updatedControls = updateObject(this.state.controls, {
    //   dateStart: updateObject(this.state.controls.dateStart, {
    //     value: '',
    //     valid: true,
    //     touched: false,
    //   }),
    //   dateEnd: updateObject(this.state.controls.dateEnd, {
    //     value: '',
    //     valid: true,
    //     touched: false,
    //   }),
    //   timeStart: updateObject(this.state.controls.timeStart, {
    //     value: null,
    //     valid: true,
    //     touched: false,
    //   }),
    //   timeEnd: updateObject(this.state.controls.timeEnd, {
    //     value: null,
    //     valid: true,
    //     touched: false,
    //   }),
    // });

    const updatedRenderStatus = updateObject(this.state.renderStatus, {
      showGiftIntro,
      showModalDrawer,
      drawerContents,
    });
    this.setState({ renderStatus: updatedRenderStatus, isGift: true });
  };

  handleTransformPostToGift = () => {
    const updatedControls = updateObject(this.state.controls, {
      dateStart: updateObject(this.state.controls.dateStart, {
        value: '',
        valid: true,
        touched: false,
      }),
      dateEnd: updateObject(this.state.controls.dateEnd, {
        value: '',
        valid: true,
        touched: false,
      }),
      timeStart: updateObject(this.state.controls.timeStart, {
        value: null,
        valid: true,
        touched: false,
      }),
      timeEnd: updateObject(this.state.controls.timeEnd, {
        value: null,
        valid: true,
        touched: false,
      }),
    });
    this.setState({ controls: updatedControls });
    this.toggleGiftIntro();
  };

  closeGiftMessage = () => {
    const updatedRenderStatus = updateObject(this.state.renderStatus, {
      showGiftMessage: false,
    });
    this.setState({ renderStatus: updatedRenderStatus });
  };

  toggleLogGifteeDrawer = () => {
    if (this.state.isGift) {
      this.toggleRenderStatus('Gift To');
    } else {
      this.toggleRenderStatus('Logs');
    }
  };

  toggleDialogue = (dialogueName) => {
    const updatedRenderStatus = updateObject(this.state.renderStatus, {
      ...this.state.renderStatus,
      dialogueContents: this.state.renderStatus.dialogueContents === dialogueName ? null : dialogueName,
    });
    this.setState({ renderStatus: updatedRenderStatus });
  };

  handlePostImageReorder = (reorderedPostImages) => {
    this.props.onReorderPostImages(reorderedPostImages);
    this.setState({ formTouched: true });
  };

  handleClose = () => {
    if (this.props.isDraft) {
      this.handleDraftsRedirect();
    } else {
      this.props.close();
    }
  };

  handleFormClose = () => {
    if (this.state.formTouched === true) {
      this.toggleDialogue('ClosePostDialogue');
    } else {
      this.handleClose();
    }
  };

  dismissGiftIntro = () => {
    localStorage.setItem('giftIntroDismissed', true);
    this.toggleGiftIntro();
  };

  hasDismissedGiftIntro = () => {
    return localStorage.getItem('giftIntroDismissed') !== null;
  };

  render = () => {
    let categoryImage = null;
    if (this.state.controls.contentCategory.value !== '') {
      categoryImage = categoryImages.find((category) => category.name === this.state.controls.contentCategory.value);
    }

    let postFormDrawers = null;
    if (this.state.renderStatus.showModalDrawer === true) {
      postFormDrawers = (
        <PostFormDrawers
          show={this.state.renderStatus.showModalDrawer}
          openedDrawer={this.state.renderStatus.drawerContents}
          shortWindow={this.props.shortWindow}
          toggleRenderStatus={this.toggleRenderStatus}
          handleUpdateLogControls={this.handleUpdateLogControls}
          updateTags={this.updateTags}
          controls={this.state.controls}
          postingAs={this.props.postingAs}
          logs={this.props.logs}
          defaultMapSettings={this.state.defaultMapSettings}
          inputChangedHandler={this.inputChangedHandler}
          setContentCategory={this.setContentCategory}
          handleCategoryPromptSelection={this.handleCategoryPromptSelection}
          images={this.props.postImages}
          selectedCategory={this.state.controls.contentCategory.value}
          handleGifteesUpdate={this.handleGifteesUpdate}
          handleGifteeLogsUpdate={this.handleGifteeLogsUpdate}
          handleGifteesClear={this.handleGifteesClear}
          handleLocationUpdate={this.handleLocationUpdate}
          handleLocationDeletion={this.handleLocationDeletion}
          handleImageDeletion={this.handleImageDeletion}
          handlePostImageReorder={this.handlePostImageReorder}
          handleTimeSelect={this.handleTimeSelect}
          handleTimeClear={this.handleTimeClear}
          handleDateSelect={this.handleDateSelect}
          handleDateClear={this.handleDateClear}
          handleOngoingSelection={this.handleOngoingSelection}
          handleUppyUploadStart={() => this.setState({ uppyUploading: true })}
          handleUppyUploadCompletion={() => this.setState({ uppyUploading: false, formTouched: true })}
        />
      );
    }

    const dateTimeDisplay =
      (this.state.controls.dateStart.value === null || this.state.controls.dateStart.value === '') &&
      this.state.controls.dateEnd.value === null &&
      this.state.controls.timeStart.value === null
        ? ''
        : this.state.controls.timeStart.value || this.state.controls.timeEnd.value
        ? `${formatDateRangeForPostFormDisplay(
            this.state.controls.dateStart.value,
            this.state.controls.dateEnd.value,
            this.state.controls.dateEnd.ongoing,
          )}\n${formatTimeRangeForPostFormDisplay(
            this.state.controls.timeStart.value,
            this.state.controls.timeEnd.value,
            this.state.controls.dateEnd.ongoing,
          )}`
        : ` \n${formatDateRangeForPostFormDisplay(
            this.state.controls.dateStart.value,
            this.state.controls.dateEnd.value,
            this.state.controls.dateEnd.ongoing,
          )}`;
    let postFormContainer = null;
    let dialogue = null;

    if (this.props.loading !== true) {
      const isUpdated = !this.state.isNewlyCreatedDraft && ((this.props.post && this.props.post.Post.PostType === 'Draft') || this.state.isDraft);
      if (this.state.renderStatus.dialogueContents === 'Draft Saved Dialogue') {
        dialogue = (
          <FormDialogue
            show
            className="postFormFormDialogue"
            title={isUpdated ? 'Draft Updated!' : 'Draft Saved!'}
            desc={`Your draft was ${isUpdated ? 'updated' : 'saved'} and can be found in the main menu.`}
            cancelled={() => this.toggleDialogue('Draft Saved Dialogue')}
            cancelText="Continue Editing this Post"
          >
            <span onClick={this.handleDraftsRedirect} className={classes.TagCategory}>
              Go to Drafts
            </span>
            <span onClick={() => this.toggleDialogue('Draft Saved Dialogue')} className={classes.TagCategory}>
              Continue Editing this Post
            </span>
          </FormDialogue>
        );
      } else if (this.state.renderStatus.dialogueContents === 'DeletePostConfirmation') {
        dialogue = <DeletePostDialogue clicked={this.handlePostDelete} cancelled={() => this.toggleDialogue('DeletePostConfirmation')} />;
      } else if (this.state.renderStatus.dialogueContents === 'ClosePostDialogue') {
        dialogue = (
          <ClosePostDialogue
            isGift={this.state.isGift}
            newPost={this.props.newPost}
            cancelled={this.props.close}
            clicked={this.props.newPost === true || this.state.isDraft ? this.handleDraftSaving : this.handlePostSubmit}
          />
        );
      } else if (this.state.renderStatus.dialogueContents === 'Title Needed Dialogue') {
        dialogue = <TitleNeededDialogue clicked={() => this.toggleDialogue('Title Needed Dialogue')} />;
      }
    }

    if (this.props.loading === true) {
      postFormContainer = <Spinner />;
    } else {
      let selectedLogNames = this.state.controls.logs.logNames;
      // If any logs are selected, sort to match order that's starndard for app (including the order of the selected logs in the LogSelector)
      if (selectedLogNames.length > 0 && this.props.logs.length > 0) {
        let sortedLogsList = this.props.logs.map((log) => log.Log);

        sortedLogsList = sortLogNamesForDisplay(sortedLogsList);
        selectedLogNames = sortedLogsList.filter((log) => this.state.controls.logs.value.includes(log.Id)).map((log) => log.Name);
      }

      const logTags = selectedLogNames.map((logName) => ({ tagClassName: this.state.controls.logs.tagClassName, tag: logName }));

      const gifteeTags = this.state.controls.gifteeMembers.names.map((memberName) => ({
        tagClassName: this.state.controls.logs.tagClassName,
        tag: memberName,
      }));
      const selectedTags = [];
      const tagTypes = ['whatTags', 'whoTags', 'locationTags'];
      const filePickerDrawers = ['Images', 'FilePicker'];
      tagTypes.forEach((tagType, i) =>
        this.state.controls[tagType].value.forEach((tag) => selectedTags.push({ tagClassName: capitalize(tagTypes[i]), tag })),
      );
      const postFormClasses = [classes.PostForm];
      let postForm = null;
      const imagesFieldClickDrawer = this.state.controls.images.value.length > 0 ? 'Reorder' : 'FilePicker';
      const locationDisplay =
        (this.state.controls.location.location.length > 0 && this.state.controls.location.location2.length > 0) ||
        (this.state.controls.location.location.length === 0 && this.state.controls.location.location2.length === 0)
          ? `${this.state.controls.location.location}\n${this.state.controls.location.location2}`
          : this.state.controls.location.location2.replace(', ', '\n');

      if (this.state.renderStatus.showModalDrawer) postFormClasses.push(classes.DrawerOpen);
      if (this.state.isGift) postFormClasses.push(classes.GiftPost);

      const saveDraftClasses = [classes.SaveDraft];
      if (this.state.controls.title.value.length < 1) {
        saveDraftClasses.push(classes.Disabled);
      }

      if (this.state.renderStatus.showGiftIntro && !this.props.returnedToPostFormFromPreview) {
        postForm = <GiftPostIntro newPost={this.props.newPost} dismiss={this.dismissGiftIntro} />;
      } else {
        postForm = (
          <div className={classes.PostFormContainer}>
            <div id="logs-field" className={classes.LogsField}>
              <TagInput
                prompt={this.state.isGift ? 'Gift To:' : this.state.controls.logs.value.length === 0 ? 'To: Logs' : 'To:'}
                isGift={this.state.isGift}
                shortWindow={this.props.shortWindow}
                offsetWidth={this.state.isGift ? '71px' : '93px'}
                drawerOpen={this.state.renderStatus.showModalDrawer}
                selected={this.state.renderStatus.drawerContents === 'Logs'}
                clicked={this.toggleLogGifteeDrawer}
                tags={this.state.isGift === false ? logTags : gifteeTags}
                tagCategory="Logs"
                iconImage="Users"
              />
              <span
                style={{ display: this.state.renderStatus.drawerContents === (this.state.isGift ? 'Gift To' : 'Logs') ? 'inline-block' : 'none' }}
                className={classes.rightCaret}
              />
            </div>
            <div className={classes.SelectCategory} onClick={() => this.toggleRenderStatus('Choose Content Type')}>
              {categoryImage !== null ? <categoryImage.image alt="category image" /> : <img src={SelectCategory} alt="Select Category" />}
              <span className={classes.CategorySelectorChevron}>
                <FontAwesomeIcon icon="chevron-down" />
              </span>
              {!this.state.controls.contentCategory.value === '' ? <h4>Choose content type</h4> : null}
            </div>
            <div className={classes.TitleField}>
              <DisplayTextArea
                shortWindow={this.props.shortWindow}
                type="Title"
                lines={3}
                drawerOpen={this.state.renderStatus.showModalDrawer}
                isGift={this.state.isGift}
                selected={this.state.renderStatus.drawerContents === 'Add Title'}
                clicked={() => this.toggleRenderStatus('Add Title')}
                iconImage="Lightbulb"
                value={this.state.controls.title.value}
                placeholder={this.state.controls.title.elementConfig.placeholder}
                invalid={!this.state.controls.title.valid}
                shouldValidate={this.state.controls.title.validation}
                validationError={this.state.controls.title.validation.required === true ? this.state.controls.title.validation.validationError : null}
              />
              <span
                style={{ display: this.state.renderStatus.drawerContents === 'Add Title' ? 'inline-block' : 'none' }}
                className={classes.rightCaret}
              />
            </div>
            <div className={classes.DatesField}>
              <DisplayTextArea
                type="Dates"
                isGift={this.state.isGift}
                selected={this.state.renderStatus.drawerContents === 'Dates'}
                clicked={() => this.toggleRenderStatus('Dates')}
                iconImage="Calendar"
                placeholder={this.state.controls.dateStart.elementConfig.placeholder}
                value={dateTimeDisplay === ' \n' ? '' : dateTimeDisplay}
                invalid={!this.state.controls.dateStart.valid}
                validationError={
                  this.state.controls.dateStart.validation.required === true ? this.state.controls.desc.validation.validationError : null
                }
                touched={this.state.controls.dateStart.touched}
              />
              <span
                style={{ display: this.state.renderStatus.drawerContents === 'Dates' ? 'inline-block' : 'none' }}
                className={classes.rightCaret}
              />
            </div>
            <div className={classes.AboutField}>
              <DisplayTextArea
                shortWindow={this.props.shortWindow}
                type="About"
                id="about-form-field"
                lines={4}
                drawerOpen={this.state.renderStatus.showModalDrawer}
                isGift={this.state.isGift}
                selected={this.state.renderStatus.drawerContents === 'About'}
                clicked={() => this.toggleRenderStatus('About')}
                iconImage="List"
                placeholder={this.state.controls.desc.elementConfig.placeholder}
                value={this.state.controls.desc.value}
                invalid={!this.state.controls.desc.valid}
                shouldValidate={this.state.controls.desc.validation}
                validationError={this.state.controls.desc.validation.required === true ? this.state.controls.desc.validation.validationError : null}
              />
              <span
                style={{ display: this.state.renderStatus.drawerContents === 'About' ? 'inline-block' : 'none' }}
                className={classes.rightCaret}
              />
            </div>
            <div className={classes.FilePickerField}>
              <ImagesDisplayInputField
                imageThumbUrls={this.state.controls.images.imageThumbUrls}
                imageIds={this.state.controls.images.value}
                images={this.props.postImages}
                className="PostForm"
                isGift={this.state.isGift}
                selected={filePickerDrawers.includes(this.state.renderStatus.drawerContents) === true}
                clicked={() => this.toggleRenderStatus(imagesFieldClickDrawer)}
                placeholder={this.state.controls.images.value.length > 0 ? null : 'Images'}
                iconImage="Camera"
              />
              <span
                style={{ display: this.state.renderStatus.drawerContents === 'FilePicker' ? 'inline-block' : 'none' }}
                className={classes.rightCaret}
              />
            </div>
            <div className={classes.LocationField}>
              <DisplayTextArea
                type="Location"
                isGift={this.state.isGift}
                selected={this.state.renderStatus.drawerContents === 'Location'}
                clicked={() => this.toggleRenderStatus('Location')}
                iconImage="Map"
                placeholder={this.state.controls.location.elementConfig.placeholder}
                value={locationDisplay === '\n' ? '' : locationDisplay}
                invalid={!this.state.controls.location.valid}
                shouldValidate={this.state.controls.location.validation}
                validationError={
                  this.state.controls.location.validation.required === true ? this.state.controls.location.validation.validationError : null
                }
              />
              <span
                style={{ display: this.state.renderStatus.drawerContents === 'Location' ? 'inline-block' : 'none' }}
                className={classes.rightCaret}
              />
            </div>
            <div className={classes.TagsField}>
              <TagInput
                shortWindow={this.props.shortWindow}
                tags={selectedTags}
                drawerOpen={this.state.renderStatus.showModalDrawer}
                isGift={this.state.isGift}
                selected={this.state.renderStatus.drawerContents === 'Tags'}
                clicked={() => this.toggleRenderStatus('Tags')}
                tagCategory="Tags"
                placeHolder="Tags"
                iconImage="Tags"
              />
              <span style={{ display: this.state.renderStatus.drawerContents === 'Tags' ? 'inline-block' : 'none' }} className={classes.rightCaret} />
            </div>
          </div>
        );
      }

      let giftMessage = null;
      if (
        this.props.post !== undefined &&
        this.props.post.Post.MessageToUser !== undefined &&
        this.state.renderStatus.showGiftMessage &&
        this.state.isDraft
      )
        giftMessage = (
          <PostItMessage close={this.closeGiftMessage} positionLeft="287.5px" positionTop="65px" message={this.props.post.Post.MessageToUser} />
        );
      let headerActionButton = (
        <Button
          className
          btnType="SavePost"
          disabled={!this.state.formIsValid || this.state.uppyUploading}
          clicked={() => this.handlePreviewLaunch(false)}
        >
          PREVIEW
        </Button>
      );
      if (this.state.uppyUploading) {
        headerActionButton = (
          <Button className btnType="SavePost" disabled>
            Uploading...
          </Button>
        );
      } else if (this.state.isGift) {
        if (this.state.renderStatus.showGiftIntro && !this.props.returnedToPostFormFromPreview) {
          headerActionButton = (
            <Button className btnType="SavePost" clicked={this.toggleGiftIntro}>
              CREATE
            </Button>
          );
        } else {
          headerActionButton = (
            <Button
              className
              btnType="SavePost"
              disabled={this.state.controls.gifteeMembers.ids.length === 0 && this.state.controls.title.value.length > 0}
              clicked={() => this.handlePreviewLaunch(true)}
            >
              PREVIEW
            </Button>
          );
        }
      }

      postFormContainer = (
        <div className={classes.PostFormWindow}>
          <div className={postFormClasses.join(' ')}>
            {giftMessage}
            <div className={classes.Header}>
              <FontAwesomeIcon className={classes.closeAddPostOverlay} onClick={this.handleFormClose} icon="times" />
              <h2>
                {this.state.isGift || this.props.isGift
                  ? 'Create Gift Post'
                  : this.props.newPost === true || this.state.isDraft
                  ? 'Create Post'
                  : 'Edit Post'}
              </h2>
              <div className={classes.AddPostButton}>{headerActionButton}</div>
            </div>
            {postForm}
            <div className={classes.Footer}>
              {!this.props.newPost && this.state.isGift === false ? (
                <div className={classes.DeletePost}>
                  <FontAwesomeIcon icon="trash" className={classes.DeleteIcon} onClick={() => this.toggleDialogue('DeletePostConfirmation')} />{' '}
                </div>
              ) : null}
              {this.state.renderStatus.showGiftIntro === false ? (
                <div onClick={this.handleDraftSaving} className={saveDraftClasses.join(' ')}>
                  {this.state.isDraft ? 'Update' : 'Save'} Draft
                </div>
              ) : null}
              {this.props.postingAs.GiftsDraftsCount && this.props.postingAs.GiftsDraftsCount > 0 ? (
                <div className={classes.GiftsAndDraftsLink} onClick={this.props.onToggleGiftsDraftsModal}>
                  Drafts & Gifts ({this.props.postingAs.GiftsDraftsCount})
                </div>
              ) : null}
              {this.state.isGift === false ? (
                <div className={classes.GiftDraft} onClick={this.handleTransformPostToGift}>
                  Gift a Post
                </div>
              ) : null}
            </div>
          </div>

          {postFormDrawers}
        </div>
      );
    }
    const formModalContainerClasses = [classes.PostFormModalContainer];
    if (this.props.shortWindow === true) formModalContainerClasses.push(classes.ShortWindow);
    return (
      <div>
        <div className={formModalContainerClasses.join(' ')}>{postFormContainer}</div>
        {dialogue}
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    sessionToken: state.auth.sessionToken,
    post:
      state.post.fetchedPreviewPost !== null
        ? state.post.fetchedPreviewPost
        : state.post.fetchedPost !== null
        ? state.post.fetchedPost
        : state.post.emptyPost,
    postingAs: state.user.postingAs,
    isManagedUser: state.user.signedInAs.UserId !== state.user.postingAs.UserId,
    loading: state.post.loading === true,
    currentLog: state.logs.currentLog,
    logs: state.logs.LogsDetails,
    whatTags: state.logs.Tags.WhatTags,
    locationTags: state.logs.Tags.LocationTags,
    whoTags: state.logs.Tags.WhoTags,
    submitted: state.post.submitted,
    postImages: state.post.postImages,
    removedImageIds: state.post.removedImageIds,
    deleted: state.post.deleted === true,
    imagesUpdated: state.post.imagesUpdated === true,
    newPost: state.post.newPost,
    isGift: state.post.fetchedPostIsGift,
    isDraft: state.post.isDraft,
    returnedToPostFormFromPreview: state.post.returnedToPostFormFromPreview,
    isEditingPreview: state.post.fetchedPreviewPost !== null,
    redirectPath: state.post.redirectPath,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchDrafts: () => dispatch(actions.fetchDrafts()),
    onFetchTags: () => dispatch(actions.fetchTagsForLogs()),
    onFetchLogsDetails: (userId, isManagedUser) => dispatch(actions.fetchLogsDetails(userId, isManagedUser)),
    onUploadPostImage: (Image, Type, SizeTo, CommentType) => dispatch(actions.uploadPostImage(Image, Type, SizeTo, CommentType)),
    onAddPost: (
      UserId,
      isManagedUser,
      LogIds,
      Name,
      Type,
      DateStart,
      DateEnd,
      TimeStart,
      TimeEnd,
      Desc,
      AddFileIds,
      Suggested,
      WhatTags,
      WhoTags,
      LocationTags,
      Ongoing,
      Location,
      Location2,
      LocIcon,
      LocFav,
      FavId,
      MapType,
      GeoLocation,
      Center,
      Pitch,
      Heading,
      Zoom,
      isDraft,
      MessageToUser,
      SaveCopyForSelf,
    ) =>
      dispatch(
        actions.addPost(
          UserId,
          isManagedUser,
          LogIds,
          Name,
          Type,
          DateStart,
          DateEnd,
          TimeStart,
          TimeEnd,
          Desc,
          AddFileIds,
          Suggested,
          WhatTags,
          WhoTags,
          LocationTags,
          Ongoing,
          Location,
          Location2,
          LocIcon,
          LocFav,
          FavId,
          MapType,
          GeoLocation,
          Center,
          Pitch,
          Heading,
          Zoom,
          isDraft,
          MessageToUser,
          SaveCopyForSelf,
        ),
      ),
    onUpdatePost: (
      PostId,
      LogIds,
      Name,
      Type,
      DateStart,
      DateEnd,
      TimeStart,
      TimeEnd,
      Desc,
      AddFileIds,
      Suggested,
      WhatTags,
      WhoTags,
      LocationTags,
      RemovedImageIds,
      Ongoing,
      Location,
      Location2,
      LocIcon,
      LocFav,
      FavId,
      MapType,
      GeoLocation,
      Center,
      Pitch,
      Heading,
      Zoom,
      isDraft,
      CopyCommentFileIds,
      isManagedUser,
      UserId,
    ) =>
      dispatch(
        actions.editPost(
          PostId,
          LogIds,
          Name,
          Type,
          DateStart,
          DateEnd,
          TimeStart,
          TimeEnd,
          Desc,
          AddFileIds,
          Suggested,
          WhatTags,
          WhoTags,
          LocationTags,
          RemovedImageIds,
          Ongoing,
          Location,
          Location2,
          LocIcon,
          LocFav,
          FavId,
          MapType,
          GeoLocation,
          Center,
          Pitch,
          Heading,
          Zoom,
          isDraft,
          CopyCommentFileIds,
          isManagedUser,
          UserId,
        ),
      ),
    onSetPreviewPost: (Post) => dispatch(actions.setPreviewPost(Post)),
    onPostImageRemoval: (index, imageId, type) => dispatch(actions.removePostImage(index, imageId, type)),
    onHandlePostDelete: (postId, isManagedUser, UserId) => dispatch(actions.deletePost(postId, isManagedUser, UserId)),
    onReorderPostImages: (reorderedPostImages) => dispatch(actions.reorderPostImages(reorderedPostImages)),
    onToggleGiftsDraftsModal: () => dispatch(actions.toggleGiftsDraftsModal()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostForm));
